import MiniEndCardDemo from '../../../../class/template/ec/MiniEndCardDemo'
import App from '@class/App.js'
import {getUrlParams} from "../../../../common/util";
import {onBroadcast} from "../../../../api";


window.MTG_LAUNCH_miniEndCardDemo = function (cb) {

    /*App.onBroadcast('readyToShow', ()=>{
        App.videoBridgeReadyStatusHasReady()
    })*/
    App.onJSBridgeConnected(()=>{init()})

    function init(){
        App.initSingleCampaign(MiniEndCardDemo, cb).then(({data, tpl})=>{
            //const { campaignList } = data

            /*tpl.onAllTplPreloadFinished(()=>{
                //App.videoBridgeReadyStatusHasReady()
            })*/
            //App.readyToShowAD()

            App.onAdShow((res) => {
                console.warn('onAdShow((res) => {', {res})
                //tpl.show(res)
            })
        }).catch(err=>{
            console.error('promise catch an error:',err)
        })
    }
}
